import React from 'react';
import { HISTORICO_DE_ESTACIONAMENTO_GET } from '../../Api';
import useFetch from '../../Hooks/useFetch';
import useForm from '../../Hooks/useForm';
import Button from '../Forms/Button';
import Input from '../Forms/Input';
import Select from '../Forms/Select';
import Head from '../Helper/Head';
import SistemaIndisponivel from '../SistemaIndisponivel';
import styles from './Requests.module.css';
import moment from 'moment';
import Loading from '../Helper/Loading';
import MUIDataTable from 'mui-datatables';
import MaskedInput from 'react-text-mask';

const HistoricoDeEstacionamento = () => {
  const startDate = useForm();
  const endDate = useForm();
  const cpf_cnpj = useForm();
  const userType = useForm();
  const licensePlate = useForm();
  const [results, setResults] = React.useState('');
  const [status, setStatus] = React.useState('');

  const { loading, request } = useFetch();

  async function handleSubmit(event) {
    event.preventDefault();

    if (startDate.validate() && endDate.validate()) {
      const startDateConvert = moment(startDate.value).format('DDMMYYYY000000');
      const endDateConvert = moment(endDate.value).format('DDMMYYYY235900');

      const body = {
        startDate: startDateConvert,
        endDate: endDateConvert,
        cpf_cnpj: cpf_cnpj.value.replace(/\D/g, ''),
        userType: userType.value,
        licensePlate: licensePlate.value,
      };

      const { url, options } = HISTORICO_DE_ESTACIONAMENTO_GET(body);
      const { response, json } = await request(url, options);
      console.log(response);
      console.log(json);
      setResults(json.history);

      if (response === undefined || json.history === undefined) {
        setStatus(undefined);
        alert(`Erro: Tente novamente mais tarde.`);
      }

      if (response !== undefined) {
        if (json === null) return null;

        if (response.ok === false) {
          alert(`Erro: Tente novamente mais tarde.`);
        }
      }
    }
  }

  const mask = function (rawValue) {
    if (rawValue.length > 14) {
      return [
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '/',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
      ];
    } else {
      return [
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
      ];
    }
  };

  function createData(
    licensePlate,
    date_started,
    date_ended,
    parked_time,
    description,
    rule_name,
  ) {
    return {
      licensePlate,
      date_started,
      date_ended,
      parked_time,
      description,
      rule_name,
    };
  }

  const data = [];
  for (var i = 0; i < results.length; i++) {
    let dateStarted = moment(results[i].date_started).format(
      'DD/MM/YYYY HH:mm:ss',
    );
    let dateEnded = moment(results[i].date_ended).format('DD/MM/YYYY HH:mm:ss');
    let parkedTime = moment
      .utc(
        moment(results[i].date_ended || moment()).diff(
          moment(results[i].date_started),
        ),
      )
      .format('HH:mm:ss');

    data.push(
      createData(
        results[i].licensePlate,
        dateStarted,
        dateEnded,
        parkedTime,
        results[i].description,
        results[i].rule.name,
      ),
    );
  }
  // console.log(data);

  const columns = [
    {
      name: 'licensePlate',
      label: 'Placa',
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: 'date_started',
      label: 'Data de início',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'date_ended',
      label: 'Data de fim',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'parked_time',
      label: 'Tempo estacionado',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'description',
      label: 'Local do estacionamento',
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: 'rule_name',
      label: 'Regra informada pelo cliente',
      options: {
        filter: true,
        sort: true,
      },
    },
  ];

  const options = {
    responsive: 'simple',
    draggableColumns: {
      enabled: true,
    },
    selectableRows: 'none',
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: 'false',
    download: 'true',
    onDownload: (buildHead, buildBody, columns, data) => {
      return '\uFEFF' + buildHead(columns) + buildBody(data);
    },
    downloadOptions: {
      filename: 'HistoricoDeEstacionamento.csv',
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
    textLabels: {
      body: {
        noMatch: 'Desculpe, nenhum registro foi encontrado',
        toolTip: 'Ordenar',
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
      },
      pagination: {
        next: 'Próxima Página',
        previous: 'Página Anterior',
        rowsPerPage: 'Linhas por página:',
        displayRows: 'of', // 1-10 of 30
      },
      toolbar: {
        search: 'Pesquisar',
        viewColumns: 'Selecionar Colunas',
        filterTable: 'Filtrar Tabela',
      },
      filter: {
        title: 'FILTROS',
        reset: 'limpar',
        all: 'Todos',
      },
      viewColumns: {
        title: 'Mostrar Colunas',
        titleAria: 'Mostrar/Esconder Colunas da Tabela',
      },
    },
    customToolbarSelect: () => {},
  };

  if (status === undefined || results.length === undefined) {
    return <SistemaIndisponivel />;
  }
  if (loading) return <Loading />;
  if (results === '') {
    return (
      <section className="container animeLeft">
        <Head title="Histórico de Estacionamento" />
        <h1 className="title">Histórico de Estacionamento</h1>
        <form onSubmit={handleSubmit}>
          <div className={styles.flex}>
            <Input
              className={styles.input}
              label="Data Início"
              type="date"
              name="startDate"
              required
              {...startDate}
            />

            <Input
              className={styles.input}
              label="Data Final"
              type="date"
              name="endDate"
              required
              {...endDate}
            />
          </div>

          <div className={styles.flex}>
            <div className={styles.wrapper}>
              <label htmlFor="cpf_cnpj" className={styles.label}>
                CPF ou CNPJ (opcional)
              </label>
              <MaskedInput
                mask={mask}
                className={styles.input}
                placeholder="CPF ou CNPJ do cliente"
                guide={false}
                id="cpf_cnpj"
                name="cpf_cnpj"
                onBlur={() => {}}
                onChange={() => {}}
                {...cpf_cnpj}
              />
            </div>

            {cpf_cnpj.value.length > 0 ? (
              <Select
                className={styles.select}
                label="Tipo de Usuário (opcional)"
                name="userType"
                required
                {...userType}
              >
                <option value="">Selecione</option>
                <option value="1">APP</option>
                <option value="2">PDV</option>
              </Select>
            ) : (
              <Select
                className={styles.select}
                label="Tipo de Usuário (opcional)"
                name="userType"
                {...userType}
              >
                <option value="">Selecione</option>
                <option value="1">APP</option>
                <option value="2">PDV</option>
              </Select>
            )}
          </div>

          <div className={styles.flex}>
            <Input
              className={styles.input}
              label="Placa (opcional)"
              type="text"
              name="licensePlate"
              placeholder="Placa do veículo"
              maxLength="7"
              {...licensePlate}
            />
          </div>
          <div className={styles.wrapper}></div>
          {loading ? (
            <Button disabled>Localizando Histórico...</Button>
          ) : (
            <Button>Localizar Histórico</Button>
          )}
        </form>
      </section>
    );
  } else {
    return (
      <section className="animeLeft">
        <Head title={'Histórico de Estacionamento'} />
        <MUIDataTable
          title={'Histórico de Estacionamento'}
          data={data}
          columns={columns}
          options={options}
        />
      </section>
    );
  }
};

export default HistoricoDeEstacionamento;
